<template>
  <v-container
  ref="userProjectDiv"
  v-resize="onResize"
  fluid
  grid-list-md>
    <v-layout column v-if="userProject">

      <v-flex xs12>
        <!-- id: {{ $route.params.id }} -->
        <v-layout row>
          <v-flex grow>
            <h6 class="title">{{ userProject.title }}</h6>
          </v-flex>
          <v-flex shrink>
            <v-btn
            v-if="completedSurveys < maxSurveysForUserProject"
            :disabled="completedSurveys >= allowedSurveys"
            color="primary"
            @click="gotoSurvey()"
            >Start test</v-btn>
            Completed test: {{ completedSurveys }} / {{ maxSurveysForUserProject }}
          </v-flex>
        </v-layout>
      </v-flex>
  
      <v-flex xs12 v-if="showError">
        <v-alert
        v-model="showError"
        type="error"
        icon="warning"
        dismissible>
          {{ errorMessage }}
        </v-alert>
      </v-flex>

      <v-flex xs12 v-if="userProject">
        <v-layout
        :row="!isMobile"
        :column="isMobile"
        justify-space-between>
          <v-flex
          :key="index"
          v-for="(survey, index) in userProject.surveys"
          class="center-content"
          @click="gotoScreenshot(user.uid, index, survey)"
          v-bind:class="{clickable: survey.completed}"
          >
            <splines-chart
            class="chart"
            :chart-layout="chartLayout"
            :survey="survey"
            :show-debug="showDebug"
            :show-numbers="showNumbers"
            :show-area-labels="showAreaLabels"
            :show-title-label="showTitleLabel"
            />
          </v-flex>
        </v-layout>

        <!-- :chart-title="getChartTitle(survey)" -->
        <!-- :answers="survey.answers" -->
        <!-- v-if="userProject.surveys[0] && userProject.surveys[0].answers" -->
        <!-- :chart-data="userProject.surveys[0].answers" -->
        <!-- :b-debug="showDebug" -->
        <!-- :b-numbers="showNumbers" -->
        <!-- :b-area-labels="showAreaLabels" -->
        <!-- :b-title-label="showTitleLabel" -->
        <!-- <ica-body-chart
        :chart-data="userProject.surveys[0].answers"
        /> -->
      </v-flex>

      <v-layout align-start>
        <v-flex shrink>
          <chart-legend></chart-legend>
        </v-flex>
      </v-layout>

    </v-layout>

  </v-container>
</template>

<script>
// @ is an alias to /src
import { mapState, mapMutations, mapActions } from 'vuex'
// import { firebase } from '@/firebase.js';
// import { auth, firestore, db } from '@/firebase.js';
import SplinesChart from '@/components/SplinesChart'
// import IcaBodyChart from '@/components/IcaBodyChart'
import ChartLegend from '@/components/ChartLegend'
import icabody from '@/icabody.js'

export default {
  name: 'Project',

  components: {
    SplinesChart,
    ChartLegend
  },

  data: () => ({
    debug: false,

    showError: false,
    errorMessage: '',

    maxSurveysForUserProject: icabody.getMaxSurveysForUserProject(),
    chartLayout: {
      size: 400,
      minifiedSize: 250,
      anchorLeft: 0,
      anchorTop: 0
    },
    // chartTitle: null,
    showDebug: false,
    showNumbers: true,
    showAreaLabels: true,
    showTitleLabel: true,

    unsubscribeCurrentProjectFunctionListner: null
  }),

  props: {
  },

  computed: {
    ...mapState('auth', {
      user: state => state.user
    }),
    ...mapState ('usersProjects', {
      userProject: state => state.userProject, // map `this.userProject` to `this.$store.state.userProject`
      currentProject: state => state.currentProject // map `this.currentProject` to `this.$store.state.currentProject`
    }),

    ...mapState('util', {
      isMobile: state => state.isMobile // map `this.isMobile` to `this.$store.state.util.isMobile`
    }),

    allowedSurveys () {
      return this.currentProject && this.currentProject.allowedSurveys ? this.currentProject.allowedSurveys : 0
    },
    completedSurveys () {
      let completedSurveys = 0
      if (this.userProject || this.userProject.surveys) {
        this.userProject.surveys.forEach((survey) => {
          if (survey.completed) {
            completedSurveys ++
          }
        })
      }
      return completedSurveys
    }
  },

  watch: {},

  created () {
    if (this.debug) console.log(this.$options.name+'.created() userProject:',this.userProject)
    // if userProject is not set (from a direct link) reload all projects
    if (!this.userProject) {
      // read userProjects from the db and store
      this.readMyUserProjects()
      .then(() => {
        if (this.debug) console.log(this.$options.name+'.created() readed $route.params.id:',this.$route.params.id)
        this.showError = false
        return this.setUserProjectById(this.$route.params.id)
      })
      .catch((error) => {
        this.errorMessage = error.message
        this.showError = true
      })
    }
    if (this.debug) console.log(this.$options.name+'.created() userProject:',this.userProject)
    if (this.debug) console.log(this.$options.name+'.created() $route.params:',this.$route.params)
    if (this.debug) console.log(this.$options.name+'.created() $route.params.id:',this.$route.params.id)
    this.listenCurrentProject()
  },
  beforeDestroy () {
    if (this.debug) console.log(this.$options.name+'.beforeDestroy()');
    if (this.unsubscribeCurrentProjectFunctionListner) {
      if (this.debug) console.log(this.$options.name+'.beforeDestroy() unsubscribeCurrentProjectFunctionListner')
      this.unsubscribeCurrentProjectFunctionListner()
    }
  },


  methods: {
    ...mapMutations ('usersProjects', [
      'setUserProjectById' // map `this.setUserProjectById()` to `this.$store.commit('usersProjects/setUserProjectById')`
    ]),

    ...mapActions ('usersProjects', [
      'readCurrentProject', // map `this.readCurrentProject()` to `this.$store.dispatch('usersProjects/readCurrentProject')`
      'readMyUserProjects' // map `this.readMyUserProjects()` to `this.$store.dispatch('usersProjects/readMyUserProjects')`
    ]),

    gotoSurvey () {
      if (this.debug) console.log(this.$options.name+'.gotoSurvey() userProject:',this.userProject)
      this.$router.push('/survey/'+this.userProject.projectId)
    },

    listenCurrentProject () {
      if (this.debug) console.log(this.$options.name+'.listenCurrentProject()')
      if (this.unsubscribeCurrentProjectFunctionListner) {
        if (this.debug) console.log(this.$options.name+'.listenCurrentProject() unsubscribeCurrentProjectFunctionListner')
        this.unsubscribeCurrentProjectFunctionListner()
      }
      this.readCurrentProject(this.$route.params)
      .then((unsubscribe) => {
        this.showError = false
        this.unsubscribeCurrentProjectFunctionListner = unsubscribe;
      })
      .catch((error) => {
        this.errorMessage = error.message
        this.showError = true;
      })
    },

    onResize () {
      if (this.debug) console.log(this.$options.name+'.onResize()');
      let width = this.$refs.userProjectDiv.clientWidth
      if (this.debug) console.log(this.$options.name+'.onResize() userProjectDiv.clientWidth:', width);
      if (!this.isMobile) {
        width = (width - 16) / 3
      }
      else {
        width = width - 40
      }
      if (this.debug) console.log(this.$options.name+'.onResize() new width:', width);
      this.chartLayout.size = width
    },

    gotoScreenshot (id, index, survey) {
      if (survey.completed) {
        this.$router.push({
          name: "Screenshot",
          params: {
            project: this.$route.params.id,
            user: id,
            survey: index
          }
        });
      }
    }

  }
}
</script>

<style scoped>  /* "scoped" attribute limit the CSS to this component only */
.title {
  margin-bottom: 28px;
}
.center-content {
  text-align: center;
}
/* .chart {
  border: 1px solid #000000;
} */
</style>